import { TNonEmptyArray } from 'src/types'

export const isNonEmpty = <
  T
>(
  array: T[]
): array is TNonEmptyArray<T> => {
  return array.length !== 0
}